import { useRef } from 'react';

import { Box, Card } from '@aicon-dev/caas-core';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';
import { useTranslation } from 'react-i18next';

import { IProjectScore } from '../../libs/types';

HC_more(Highcharts);

interface ProjectScoreProps {
  projectScore?: IProjectScore;
}

export const ProjectScore = (props: ProjectScoreProps) => {
  const { projectScore } = props;
  const { t } = useTranslation('project_dashboard');

  const scoreChartRef = useRef(null);

  const scoreChartOptions = {
    chart: {
      polar: true,
      type: 'line',
      height: 350,
      zoomType: 'xy',
    },

    exporting: { enabled: false },

    series: [
      {
        name: 'Project',
        data: [
          projectScore?.totalScore ?? 0,
          projectScore?.processScore ?? 0,
          projectScore?.reportScore ?? 0,
          projectScore?.cctvScore ?? 0,
          projectScore?.comunicationScore ?? 0,
        ],
        pointPlacement: 'on',
        color: '#24524A',
        label: {
          enabled: false,
        },
      },
    ],

    title: {
      text: '',
      style: {},
    },
    subtitle: {
      text: '',
      style: {},
    },
    credits: {
      enabled: false,
    },
    pane: {
      size: '85%',
    },

    xAxis: {
      categories: [
        t('project_dashboard:m_total_score'),
        t('project_dashboard:m_process_table'),
        t('project_dashboard:m_report'),
        t('project_dashboard:m_cctv'),
        t('project_dashboard:m_to_do'),
      ],
      tickmarkPlacement: 'on',
      lineWidth: 0,
      labels: {
        distance: 5,
      },
    },

    yAxis: {
      gridLineInterpolation: 'polygon',
      lineWidth: 0,
      min: 0,
    },

    tooltip: {
      shared: true,
      pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y:,.0f}</b><br/>',
    },

    legend: {
      enabled: false,
    },
  };

  return (
    <Card
      title={'현장 관리 지수'}
      titleStyle={{
        padding: '1.5rem 1rem 0 1rem',
        fontSize: '18px',
        fontWeight: 600,
      }}
      bodyStyle={{
        padding: '1rem',
        justifyContent: 'flex-end',
      }}
    >
      {projectScore ? (
        <Box width="100%">
          <HighchartsReact
            highcharts={Highcharts}
            options={scoreChartOptions}
            ref={scoreChartRef}
          />
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center">
          {t('project_dashboard:m_no_data')}
        </Box>
      )}
    </Card>
  );
};
